import { render, staticRenderFns } from "./UnAttributesViewProduct.vue?vue&type=template&id=3c679a72&lang=pug&"
import script from "./UnAttributesViewProduct.vue?vue&type=script&lang=js&"
export * from "./UnAttributesViewProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports